import { render, staticRenderFns } from "./StateBadge.vue?vue&type=template&id=c649188c&scoped=true&"
import script from "./StateBadge.vue?vue&type=script&lang=js&"
export * from "./StateBadge.vue?vue&type=script&lang=js&"
import style0 from "./StateBadge.vue?vue&type=style&index=0&id=c649188c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c649188c",
  null
  
)

export default component.exports